import { useTranslation } from 'react-i18next';

/**
 * Resolve a conventional tool label from the `chat` namespace:
 * `tools.<toolName>.<slot>` falling back to `tools.$default.<slot>`.
 *
 * Slots are the derived status kinds (`running`, `complete`, `error`,
 * `cancelled`, `awaitingInput`) plus `progress` (the thread progress
 * bubble). Interpolation values come from the tool's `labelValues` plus
 * chrome-supplied values (e.g. `{{error}}` on the error slot).
 */
export function useToolLabel() {
  const { t } = useTranslation('chat');
  // Conventional keys are derived from the runtime wire tool name, which the
  // statically-typed i18next key surface cannot express — single widening cast.
  const translate = t as unknown as (keys: string[], options?: Record<string, unknown>) => string;
  return (toolName: string | undefined, slot: string, values?: Record<string, unknown>) =>
    translate([`tools.${toolName}.${slot}`, `tools.$default.${slot}`], values);
}
